import axios from 'axios'
import { $requestToken } from '.'
import { APP_TOKEN_KEY } from '../constants'
import { loadValue } from '../localStorage'

const instance = axios.create({
  baseURL: process.env.API_SERVICE_HOST,
  timeout: 60000,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
})

instance.interceptors.request.use((config) => {
  const appToken = loadValue(APP_TOKEN_KEY)

  if (appToken) config.headers['Authorization'] = `Bearer ${appToken}`

  return config
})

instance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config

    if (error.config && error.response && error.response.status === 401) {
      const response = await $requestToken()

      originalRequest.headers['Authorization'] = `Bearer ${response.access_token}`

      return instance(originalRequest)
    }

    return Promise.reject(error)
  },
)

export const $get = async (url, config = {}) => await instance.get(url, config)
export const $post = async (url, data, config = {}) => await instance.post(url, data, config)
